import { useAppContext } from "@contexts/AppContext";
import { useStorageContext } from "@contexts/StorageContext";
import { useEffect } from "react";
import { COOKIE_CONSENT_KEY, CONSENT_CHANGED_EVENT } from "./consent";
import { initMonitoring, setMonitoringPaused } from "./faro";

/**
 * Starts browser monitoring once the runtime env is loaded and the user has
 * accepted the cookie notice, then follows later answers: accepting starts
 * or resumes it, declining pauses it. Renders nothing. Must be mounted
 * inside AppProvider and StorageProvider.
 */
export function MonitoringInit() {
  const { env } = useAppContext();
  const { storage } = useStorageContext();

  useEffect(() => {
    const consent = () => storage.get(COOKIE_CONSENT_KEY);
    const apply = () => {
      if (consent() !== "accepted") {
        setMonitoringPaused(true);
        return;
      }
      void initMonitoring({
        url: env.NA_FARO_URL,
        environment: env.NA_FARO_ENV,
        version: PKG_VERSION,
        consent: consent(),
      })
        // Re-check on resolve: a decline can land while the SDK loads.
        .then(() => setMonitoringPaused(consent() !== "accepted"));
    };

    apply();
    window.addEventListener(CONSENT_CHANGED_EVENT, apply);
    window.addEventListener("storage", apply); // answers given in other tabs
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, apply);
      window.removeEventListener("storage", apply);
    };
  }, [env.NA_FARO_URL, env.NA_FARO_ENV, storage]);

  return null;
}
